<template>
    <DForm @submit.prevent="submitForm">
        <div
            v-for="(translation, key) in translations"
            :key="key"
        >
            <DCard
                padding
                :title="defaultLanguageLabel(translation)"
                class="mb-3"
            >
                <DFormRow
                    :label="__('settings.credit_note_types.form.title')"
                    :is-required="true"
                    :hint="__('settings.credit_note_types.form.title_hint')"
                >
                    <DInput
                        id="title"
                        v-model="form.translations[key].title.value"
                        :placeholder="__('settings.credit_note_types.form.title')"
                        add-input-classes="bg-light"
                        :is-valid="isFormFieldValid('name')"
                        maxlength="45"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.credit_note_types.form.text')"
                    :hint="__('settings.credit_note_types.form.text_hint')"
                >
                    <DFormTextarea
                        id="text"
                        v-model="form.translations[key].text.value"
                        :is-valid="isFormFieldValid('text')"
                    />
                </DFormRow>
            </DCard>
        </div>
        <DFormControls
            :cancel-route="$route('settings.credit-note-types.index')"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'

const props = defineProps({
    creditNoteType: {
        type: Object,
        default: () => {
            return {}
        }
    },
    translations: {
        type: Object,
        default: () => {
            return {}
        }
    },
    defaultTenantLanguage: {
        type: String,
        default: ''
    }
})

const form = useForm({
    translations: props.translations
})

const submitForm = () => {
    form.post(route('settings.credit-note-types.translations-update', { creditNoteType: props.creditNoteType.id ?? 0 }))
}

const defaultLanguageLabel = (translation) => props.defaultTenantLanguage.value === translation.language.value ? `${__('settings.default_customer_language')} ${translation.language.label}` : translation.language.label

</script>

<style scoped lang="scss">

</style>
